import {
  ActionType,
  IChangeStressPayload,
  IChangeStressResponse,
} from "models/stressCheck/changeStress";

export const changeStressAction = (payload: IChangeStressPayload) => {
  return {
    type: ActionType.CHANGE_STRESS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.CHANGE_STRESS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IChangeStressResponse) => {
  return {
    type: ActionType.CHANGE_STRESS_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.CHANGE_STRESS_RESET,
  };
};
